var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3006 13.5187L10.2886 3.10496C10.0231 2.64446 9.53111 2.36096 9.00011 2.36096C8.46911 2.36096 7.97711 2.64446 7.71161 3.10496L1.69961 13.5187C1.43411 13.9792 1.43411 14.5455 1.69961 15.0067C1.96511 15.4665 2.45636 15.75 2.98811 15.75H15.0129C15.5439 15.75 16.0359 15.4665 16.3014 15.006C16.5669 14.5455 16.5669 13.9792 16.3006 13.5187Z",
    fill: "#E85048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88422 13.3095C9.88422 13.5742 9.73047 14.25 8.99547 14.25C8.26047 14.25 8.11572 13.5735 8.11572 13.3095C8.11572 13.0507 8.27922 12.3577 8.99547 12.3577C9.71172 12.3577 9.88422 13.0507 9.88422 13.3095ZM8.18922 10.4392V7.17598C8.18922 6.72823 8.55222 6.36523 8.99997 6.36523C9.44772 6.36523 9.81072 6.72823 9.81072 7.17598V10.44C9.81072 10.887 9.44772 11.25 8.99997 11.25C8.55222 11.25 8.18922 10.887 8.18922 10.4392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.ef93eb85703332e9507c688facc5d911.svg";
export { ForwardRef as ReactComponent };